import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  helpMessage: {
    position: "absolute",
    top: 0,
    fontSize: "$option_text_size",
    fontFamily: "$option_text_style",
    textAlign: "center",
    color: "$question_text",
  },
  container: {
    paddingTop: "10vh",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  optionLabel: {
    fontSize: "$option_text_size",
    fontFamily: "$option_text_style",
    fontWeight: "bold",
    alignSelf: "center",
    color: "$question_text",
  },
  subOptions: {
    margin: 10,
  },
  checkbox: {
    width: "29vw",
    minWidth: 250,
    fontSize: "$option_icon_size",
  },
});
